import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'management',
    loadComponent: () =>
      import('./management/management.page').then((m) => m.ManagementPage),
  },
  {
    path: 'permissions',
    loadComponent: () =>
      import('./permissions/permissions.page').then((m) => m.PermissionsPage),
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./access-denied.page').then((m) => m.AccessDeniedPage),
  },
  { path: '', pathMatch: 'full', redirectTo: 'management' },
  { path: '**', redirectTo: 'management' },
];
